import { useState } from 'react';
import { Box, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import DynamicSidebar from '../components/layout/DynamicSidebar'; // Phase 5: M5.T5.2
import DashboardHeader from '../components/dashboard/DashboardHeader';
import ChatbaseLoader from '../components/common/ChatbaseLoader';

const drawerWidth = 260; // Phase 5: Updated width to match DynamicSidebar

/**
 * DashboardLayout - Main layout wrapper for dashboard pages
 * 
 * Phase 5: M5.T5.2 - Updated to use DynamicSidebar (permission-based)
 * 
 * Features:
 * - Dynamic sidebar (renders menu based on user permissions)
 * - Responsive (drawer on mobile, permanent on desktop)
 * - Header with user menu
 */
const DashboardLayout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Dynamic Sidebar - Phase 5: Permission-based menu */}
      <DynamicSidebar 
        open={mobileOpen}
        onClose={handleDrawerToggle}
        isMobile={isMobile}
      />
      
      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 2,
          width: { md: `calc(100% - ${drawerWidth}px)` }
        }}
      >
        {/* Header */}
        <DashboardHeader 
          drawerWidth={drawerWidth}
          handleDrawerToggle={handleDrawerToggle}
        />
        
        {/* Spacer for AppBar */}
        <Toolbar />
        
        {/* Page Content */}
        {children}
      </Box>
      <ChatbaseLoader layoutType="dashboard" />
    </Box>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default DashboardLayout;

